import { FC, useEffect } from 'react';
import { useMatch, useNavigate } from 'react-router';
import { Route } from '@/core/types';
import useFirstAvailableRoute from '@/features/auth/hooks/useFirstAvailableRoute';

interface ParentRouteT {
  route: Route;
}

const ParentRoute: FC<ParentRouteT> = ({ route }) => {
  const navigate = useNavigate();
  const match = useMatch(route.path);
  const firstAvailable = useFirstAvailableRoute(route.routes);
  const firstAvailablePath = firstAvailable?.path;

  useEffect(() => {
    if (!match || !firstAvailablePath) return;
    // Carry URL params from the matched parent path into the child path
    // (e.g. replace `/:id/` with `/123/`). Strip a trailing slash so e.g.
    // `/business-account/` doesn't substitute into `/business-account//trips`.
    const matchedPathname = match.pathname.replace(/\/$/, '');
    const navigationPath = firstAvailablePath.replace(match.pattern.path, matchedPathname);
    navigate(navigationPath, { replace: true });
  }, [match, firstAvailablePath, navigate]);

  return <>{route.element}</>;
};

export default ParentRoute;
